import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {PolicyService} from '../../../policy/services/policy.service';
import {PolicyQuery} from '../../../policy/state/policy.query';
import {Policy} from '../../models/policy.model';
import {PolicyStore} from '../../../policy/state/policy.store';
import {UserStore} from '../../../authentication/state/user.store';
import {API_PATH, EntryType, RouterLinks, Superflow} from '../../constants';
import {UnderwriterService} from '../../../underwriter/services/underwriter.service';
import {QuotesService} from 'src/app/modules/quotes/services/quotes.service';
import {GlobalQuestionService} from '../../services/global-question.service';
import {GetPoliciesRequest} from '../../models/get-policies-request.model';
import {DataTableDirective} from 'angular-datatables';
import {Subject} from 'rxjs';
import {QuestionFlowSessionStore} from '../../questions/state/question-flow-session.store';
import { ClaimsService } from 'src/app/modules/claim/services/claims.service';
import { ShoppingCartStore } from '../../questions/state/shopping-cart-store';
import { Question, ShoppingCartItem } from '../../models/underwriter.model';
import { PushNotifications } from '@capacitor/push-notifications';
import { ClaimStore } from 'src/app/modules/claim/state/state/claims-session.store';
import { FlowPlayerService } from '../../services/flow-player.service';
import { QuestionFlowSessionQuery } from '../../questions/state/question-flow-session.query';
import { Alert } from '../../utilities';
import { Browser } from '@capacitor/browser';
import {DomSanitizer} from '@angular/platform-browser';
import { StorageService } from '../../services/storage.service';

declare var $: any;
declare var accounting: any;
declare function notify(): any;
declare function initTableSearch($input: any): any;
declare function initTableSort($control: any): any;
declare function genMobileTableLabels($input: any): any;
declare function initCustomDropdowns(): any;
declare function initFilters($elements: any): any;
declare function initGlobalSearch(): any;
declare function initSearchRangeDatePicker(): any;

@Component({
    selector: 'app-compliance-vault',
    templateUrl: './compliance-vault.component.html',
    styleUrls: ['./compliance-vault.component.scss'],
    standalone: false
})
export class ComplianceVaultComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  @ViewChild('viewElement') viewElement: any;
  dtOptions: any = {};
  request = new GetPoliciesRequest();
  person: any;
  files: any[] = [];
  filtered: any[] = [];
  tablePolicies: Policy[] = [];
  accounting: any;
  categories: any[] = [];
  notify: any;
  showTableContent = false;
  statusFilterAll = 'All';
  productFilterAll = 'All';
  question: Question;
  brokers: any[] = [];
  insurers: any[] = [];
  users: any[] = [];
  broker_id = 0;
  RouterLinks = RouterLinks;
  selectedInsurer: any;
  mode = 'Policies';
  search_query = '';
  //searchChanged = new Subject<string>();
  brokerage_ids = [];
  broker_ids = [];
  statuses = [];
  status_ids = [1];
  product_ids = [];
  underwriting = false;
  claims = false;
  uwDataset: any;
  uwView = 'Policies';
  sort: string = 'name';
  order: string = 'asc';
  policy: any;
  items: any;
  product: any;
  url = '';
  metadata_json = {
    display_name: '',
    description: ''
  };
  display_name = '';
  description='';
  selectedFile: any;
  videos = 'webm,.mpg,.mp2, .mpeg, .mpe, .mpv,.ogg,.mp4, .m4p, .m4v,.avi,.wmv,.mov, .qt,.flv, .swf,.avchd';
  images = '.jpg,.png,.gif,.webp,.tiff,.psd,.raw,.bmp,.heif,.indd,.jpeg,.svg,.ai,.eps';
  filters: any[] = [];
 isEdit = false;
  constructor(
    private router: Router,
    private policyService: PolicyService,
    private claimStore: ClaimStore,
    private flowPlayer: FlowPlayerService,
    private userStore: UserStore,
    public quotesService: QuotesService,
    private store: PolicyStore,
    private underwriterService: UnderwriterService,
    private questionFlowSessionQuery: QuestionFlowSessionQuery,
    public policyQuery: PolicyQuery,
    private claimService: ClaimsService,
    private policyStore: PolicyStore,
    private shoppingCartStore: ShoppingCartStore,
    private questionFlowSessionStore: QuestionFlowSessionStore,
    public globalQuestionService: GlobalQuestionService,
    private ref: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private storageService: StorageService
  ) {
    const isPolicyRejected = this.router.getCurrentNavigation()?.extras?.state?.policyRejected;
    this.notify = notify();
    if (isPolicyRejected) {
      this.underwriterService.notifyToast(`Policy ${isPolicyRejected} successfully rejected`, 'info');
    }
    this.mode = this.storageService.get('mode', 'flow');
    this.question = new Question;
    
  }

  ngOnInit(): void {
    this.globalQuestionService.spinner(true);
    this.person = this.userStore.getValue();
    this.policy = this.policyQuery.getActive();
    this.question.cent_aq_question_id = 2941;
    this.question.cent_aq_question_type_id = 22;
    this.question.session_id = this.policy?.session_id;

    this.items = [];
    this.product = this.policy?.collation.find( c => c?.entry_type === 'product_selected');
    this.items = this.policy?.collation.filter( c => c?.entry_type === EntryType.item && c?.mandatory === 0 && c?.frequency_id === this.product?.frequency_id);
    if (!this.mode) {
      this.mode = 'Policies';
    }
  

    accounting.settings = {
      currency: {
        symbol: 'R ', // default currency symbol is '$'
        format: '%s%v', // controls output: %s = symbol, %v = value/number (can be object: see below)
        decimal: '.', // decimal point separator
        thousand: ' ', // thousands separator
        precision: 0, // decimal places
      },
      number: {
        precision: 0, // default precision on numbers is 0
        thousand: ' ',
        decimal: '.',
      }
    };
    this.accounting = accounting;
    this.loadfiles();
    //this.setDtOptions();
  }
 loadfiles(): void{
  this.filters = [];
  let parameters = new Map<string, string>();
  parameters.set('session_id', this.policy?.session_id);
  this.globalQuestionService.runCommandNew(`getComplianceVaultData`, parameters, false)
    .subscribe((res: any) => {
      //console.log(res);
      this.files = res;
      this.filtered = res;
      res.forEach(el => {
        if(!this.filters.includes(el?.extension.toLowerCase()))
          this.filters.push(el?.extension.toLowerCase());
      });
      //console.log(this.filters)
    })
 }
  ngAfterViewInit(): void {
    this.globalQuestionService.spinner(false);
    setTimeout(() => {
      initGlobalSearch();
      initSearchRangeDatePicker();
      this.initCustomSelect();
      this.initSearch();
    }, 2000);

  }
  initSearch(): void {
    var settings = {
      searchThreshold: 1,
    };
    var $input = $("#search-input");
    var $searchTrigger = $("#search-trigger, #search-trigger-mobile"),
      $searchContainer = $("#search-container"),
      $inputClear = $("#search-clear"),
      $content = $("#policies-all"),
      $items = $content.find(".resource-item"),
      $noResults = $("#search-noresults");

    $searchTrigger.off("click").on("click", function (e) {
      e.stopPropagation();

      $searchTrigger.removeClass("is-active");
      $searchContainer.addClass("is-active").closest(".central-filter").addClass("search-active");
      $input.focus();


    })


  }

  searchChange(): void {

    if (this.search_query !== '') {
      this.filtered = this.files.filter(f => f.display_name.toLowerCase().includes(this.search_query)
        || f.uploadedby.toLowerCase().includes(this.search_query)
        || f.description.toLowerCase().includes(this.search_query)
      );
    }
    else {
      this.filtered = this.files;
    }

    // this.request.search_query = this.search_query;
    // this.request.page = 1;
    // this.request.start = 0;
    // this.rerender();
  }
  clearSearch(): void {
    this.search_query = '';
    this.searchChange();
  }
  initCustomSelect(): void {
    $('#class-item').selectmenu({
      change: (event: any, data: { item: { value: string; element: { attributes: { nodeValue: number; }[]; }[]; }; }) => {
        if (data?.item?.value) {
          let item = {
            item_id: data?.item?.value,
            class_id: data?.item?.element[0].attributes[3].nodeValue
          }
          this.question.product_class_id = data?.item?.element[0].attributes[3].nodeValue;
          this.question.item_id = data?.item?.value;
          
        }
      }
    });
  }

  openUploadModal(): void{
    this.isEdit = false;
    this.display_name = '';
    this.description = '';
    $('#upload-file-modal').modal('show');
    setTimeout(() => {
      this.initCustomSelect();
    }, 1000);
    
  }
  getUpload(event: any): void {
    //console.log(event)
  }
  upload(): void {
    this.globalQuestionService.saveAnswer(this.question?.session_id, this.question.cent_aq_question_id, this.question.product_class_id, this.question.item_id, this.question.answer, 0, this.question?.comment, 0, this.question?.response_parameters, this.question?.vaps_id).subscribe( resp => {
      Alert('File uploaded successfully');
      this.loadfiles();
      this.selectedFile = null;
        this.display_name = '';
        this.description = '';
        $("#class-item").selectmenu('refresh', true);
        $('.dz-success').remove();
    });
  }
  getDisply(meta: any, p: string): string {
    try{
      let json = JSON.parse(meta);
      return json[p]
    }
    catch{
      return '';
    }
  }
  viewFile(file: any): void {
    this.selectedFile = file;
    this.url = `${API_PATH.UPLOAD_RESOURCE}/${file.azure_fullname}`;
    if (this.selectedFile?.extension.toLowerCase() === '.pdf'){
      this.url = `https://docs.google.com/viewer?url=${this.url}&embedded=true`;
      Browser.open({ url: this.url });
    }
    else{
      $('#view-modal').modal('show');
      //$('#view-modal').modal('show');
    }
    
  }
  downloadFile(file: any): void {
    Browser.open({ url: `${API_PATH.UPLOAD_RESOURCE}/${file.azure_fullname}`, windowName: '_blank', presentationStyle: 'fullscreen' });
  }
  setFile(file:any) :void{
    this.selectedFile = file;
  }
  deleteFile(): void{
    let parameters = new Map<string, string>();
    parameters.set('resource_id', this.selectedFile?.resource_id);
    parameters.set('person_id', this.person.person_id.toString());
    this.globalQuestionService.runCommandNew(`deleteAzureResource`, parameters, false)
      .subscribe((res: any) => {
        Alert('File deleted successfully');
        this.loadfiles();
        this.selectedFile = null;
        this.display_name = '';
        this.description = '';
      })
  }
  editFile(file: any): void{
    console.log(file);
    this.isEdit = true;
    this.selectedFile = file;
    this.display_name = file?.display_name;
    this.description = file?.description;
    $('#upload-file-modal').modal('show');
    this.url = `${API_PATH.UPLOAD_RESOURCE}/${file.azure_fullname}`;
  }
  updateFile(): void {
    //this.isEdit = false;
    console.log(this.display_name, this.description);
    if (this.display_name == '' || this.description == ''){
      Alert('Display name & description are required.')
      return;
    }
    this.metadata_json.display_name = this.display_name;
    this.metadata_json.description = this.description;
    let parameters = new Map<string, string>();
    parameters.set('resource_id', this.selectedFile?.resource_id);
    parameters.set('person_id', this.person.person_id.toString());
    parameters.set('metadata_json',JSON.stringify(this.metadata_json));
    this.globalQuestionService.runCommandNew(`updateAzureResource`, parameters, false)
      .subscribe((res: any) => {
        $('#upload-file-modal').modal('hide');
        this.isEdit = false;
        Alert('File updated successfully');
        this.selectedFile = null;
        this.display_name = '';
        this.description = '';
        this.loadfiles();
      })
   
  }
  isVideo(): boolean {
    return this.videos.includes(this.selectedFile?.extension);
  }
  isImage(): boolean {
    return this.images.includes(this.selectedFile?.extension);
  }
  setfilter(filter: string): void {
    if (filter === 'all') {
      this.filtered = this.files;
    }
    else {
      this.filtered = this.files.filter(file => file?.extension.toLowerCase() == filter);
    }
    $('.dropdown-menu ').removeClass('show');
  }
  setMetaData(): void {
    this.metadata_json.display_name = this.display_name;
    this.metadata_json.description = this.description;
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
}
